import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { DropdownItem } from 'reactstrap';
import { firstNameFirst } from "../../helpers/formatting";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class MyChartUsers extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.MyChartUsers.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { list, activeUser, onUserSelected, bundle, history, schedulingCompleted } = this.props;
        const currentPath = history && history.location.pathname;
        const prefix = '/pharmacy';
        let pathname = '/';

        if (bundle !== 'pharmacy' && currentPath) {
            pathname = currentPath;
        }

        // If we are on the confirmation step of the scheduling section, then switching a proxy user gets redirected to the dashboard.
        if (pathname.indexOf(prefix) === 0 || (bundle !== 'pharmacy' && currentPath && /^\/schedule\//.test(currentPath) && schedulingCompleted)) {
            pathname = '/'; // currentPath
        }
        //debugger;

        return (
            <div className="proxy-dropdown__health">
                {list && list.length > 0 &&
                    <div>
                        <DropdownItem header>Family Medical Record Accounts</DropdownItem>
                        {list.map((user, index) => activeUser && !activeUser.pharmacyPatientId && activeUser.index === user.index
                            ? <DropdownItem key={index}>
                                {firstNameFirst(user.displayName)}
                            </DropdownItem>
                            : <Link key={index} to={{ pathname: pathname }}>
                                <DropdownItem key={index} onClick={() => onUserSelected(user, index)}>
                                    {firstNameFirst(user.displayName)}
                                </DropdownItem>
                            </Link>
                        )}
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        history: state.session.history,
        schedulingCompleted: state.openScheduling.scheduleAppointmentSuccess || state.openScheduling.scheduleAppointmentFailed
    };
};

export default connect(mapStateToProps)(MyChartUsers);